import { ChevronDown } from 'lucide-react';
import { type PropsWithChildren } from 'react';
import {
  useSimpleFormIteratorItem,
  useTranslate,
  useWrappedSource,
} from 'ra-core';
import { useWatch } from 'react-hook-form';
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from '../../components/ui/collapsible';

/**
 * A collapsible, bordered form iterator item, labelled with the value of `labelSource`
 * (or `"<placeholder> #<n>"` while it's empty; `placeholder` is translated).
 */
export const MoonstarFormIteratorEntry = (
  props: PropsWithChildren<{
    labelSource: string;
    placeholder: string;
    defaultExpanded?: boolean;
  }>
) => {
  const source = useWrappedSource(props.labelSource);
  const value = useWatch({ name: source });
  const { index } = useSimpleFormIteratorItem();
  const translate = useTranslate();

  return (
    <Collapsible
      defaultOpen={props.defaultExpanded}
      className="w-full rounded-md border"
    >
      <CollapsibleTrigger className="group flex w-full cursor-pointer items-center justify-between gap-2 px-4 py-3 text-left">
        <span className="truncate">
          {value ||
            `${translate(props.placeholder, { _: props.placeholder })} #${index + 1}`}
        </span>
        <ChevronDown className="size-4 shrink-0 text-muted-foreground transition-transform group-data-[panel-open]:rotate-180" />
      </CollapsibleTrigger>
      {/* Keep the inputs mounted while collapsed, so they still validate (like the MUI accordion) */}
      <CollapsibleContent keepMounted className="px-4 pb-4">
        {props.children}
      </CollapsibleContent>
    </Collapsible>
  );
};
